module.exports = __webpack_public_path__ + "d308f81a9e83da0c2de642ace38dfc2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-2.jpg
// module id = 76
// module chunks = 0